module.exports = __webpack_public_path__ + "static/media/sa.f01356c4.svg";